import { render } from "./youtubeIconW.vue?vue&type=template&id=3d84b863"
import script from "./youtubeIconW.vue?vue&type=script&lang=js"
export * from "./youtubeIconW.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__